import { render, staticRenderFns } from "./TeamsportTable.vue?vue&type=template&id=bc022384"
import script from "./TeamsportTable.vue?vue&type=script&lang=js"
export * from "./TeamsportTable.vue?vue&type=script&lang=js"
import style0 from "./TeamsportTable.vue?vue&type=style&index=0&id=bc022384&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VDataTable,VProgressCircular})
